module.exports = __webpack_public_path__ + "static/media/02-2.427f03bc.webp";